// A solution's pages as links on its *Overview* (02-DESIGN/03-console/01-the-
// console.md § conventions: the tabs of a solution's page — "its pages as
// links"): each declared panel the person may open, its own page where it
// brings one. The observability solution's admin panels are the tabs of
// *Audit & usage* (hq decision 0048), so each links there, opening on its
// tab; its person's panel, *Your usage*, is under Solutions as any panel is.

import { tenantPath } from "../../address/address.ts";
import type { Manifest, Panel } from "../../wire/solutions.ts";
import { OBSERVABILITY } from "./installed.ts";

/** PAGE_TOKEN is the address token of a solution's own page beside its panels, `solutions/<name>/page`. */
export const PAGE_TOKEN = "page";

/** PageLink is one of a solution's pages as its *Overview* lists it. */
export interface PageLink {
  key: string;
  title: string;
  line?: string;
  to: string;
  /** The navigation state the link carries: the tab it opens on. */
  state?: { tab: string };
}

/**
 * pageLinks lists a solution's pages: `shown` are the panels listed for the
 * person under Solutions, `own` the person's own panels; `audit` says whether
 * the role is offered *Audit & usage*.
 */
export function pageLinks(
  tenant: string,
  name: string,
  m: Manifest,
  shown: readonly Panel[],
  own: readonly Panel[],
  audit: boolean,
): PageLink[] {
  const out: PageLink[] = [];
  for (const p of shown) {
    if (name === OBSERVABILITY) {
      if (audit) {
        out.push({
          key: p.name,
          title: p.title,
          line: "a tab of Audit & usage",
          to: tenantPath(tenant, "audit"),
          state: { tab: p.name },
        });
      }
      continue;
    }
    out.push({
      key: p.name,
      title: p.title,
      line: p.line,
      to: tenantPath(tenant, "solutions", name, p.name),
    });
  }
  for (const p of own) {
    out.push({
      key: p.name,
      title: p.title,
      line: p.line ?? "yours, in your menu",
      to: tenantPath(tenant, "solutions", name, p.name),
    });
  }
  if (m.page !== undefined) {
    out.push({
      key: PAGE_TOKEN,
      title: m.page.label,
      line: `its own page, from ${m.page.origin}`,
      to: tenantPath(tenant, "solutions", name, PAGE_TOKEN),
    });
  }
  return out;
}
